// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"982fab17","453":"673e55e3","758":"cb4b6a28"}[chunkId] + ".chunk.js";
};